module.exports = __webpack_public_path__ + "static/media/hello_img.82fbadde.png";